import { defineComponent as g, ref as x, watch as I, onMounted as _, createElementBlock as i, openBlock as u, createVNode as T, withCtx as p, Fragment as V, renderList as k, createBlock as N, unref as B, createTextVNode as C, toDisplayString as U } from "vue";
import y from "@leaflink/snitch";
import s from "lodash-es/kebabCase";
import { useRoute as P, useRouter as D } from "vue-router";
import E from "./Tab.js";
import F from "./Tabs.js";
const L = {
  class: "stash-page-navigation container",
  "data-test": "stash-page-navigation"
}, z = /* @__PURE__ */ g({
  name: "ll-page-navigation",
  __name: "PageNavigation",
  props: {
    activeIndex: { default: void 0 },
    modelValue: { default: "" },
    items: {}
  },
  emits: ["update:modelValue", "change"],
  setup(v, { emit: h }) {
    const n = v, c = h;
    n.activeIndex && y.info("The `activeIndex` prop is deprecated. Use `v-model` instead.");
    const r = P(), f = D(), d = x("");
    function o(t) {
      t !== d.value && (d.value = t, c("update:modelValue", t));
    }
    return I(
      () => n.modelValue,
      (t, e) => {
        if (e === t) return;
        const a = n.items.findIndex((l) => s(l.label) === t);
        c("change", a), o(t);
      }
    ), _(() => {
      if (!n.items.length) return;
      if (n.activeIndex !== void 0) {
        const e = n.items[n.activeIndex];
        o(s(e.label));
        return;
      }
      if (n.modelValue !== d.value) {
        o(n.modelValue);
        return;
      }
      if (!f) return;
      const t = n.items.find((e) => {
        if (e != null && e.disabled || !(e != null && e.to) && !(e != null && e.href)) return;
        const { path: a } = f.resolve((e == null ? void 0 : e.to) || (e == null ? void 0 : e.href));
        if (a === r.path)
          return !0;
        if (!r.path.includes(a)) return;
        const l = (r.path.length - r.path.lastIndexOf("/")) * -1, b = r.path.slice(0, l);
        return a === b;
      });
      t && o((t == null ? void 0 : t.value) || s(t.label));
    }), (t, e) => (u(), i("nav", L, [
      T(F, {
        "active-tab": d.value,
        "onUpdate:activeTab": o
      }, {
        default: p(() => [
          (u(!0), i(V, null, k(n.items, (a, l) => (u(), N(E, {
            key: a.label,
            value: (a == null ? void 0 : a.value) || B(s)(a.label),
            to: a.to,
            href: a.href,
            badge: a.badge,
            disabled: a.disabled,
            "data-id": l
          }, {
            default: p(() => [
              C(U(a.label), 1)
            ]),
            _: 2
          }, 1032, ["value", "to", "href", "badge", "disabled", "data-id"]))), 128))
        ]),
        _: 1
      }, 8, ["active-tab"])
    ]));
  }
});
export {
  z as default
};
//# sourceMappingURL=PageNavigation.js.map
